import { render, staticRenderFns } from "./CompletedByMeTodoView.vue?vue&type=template&id=85ed83f0"
import script from "./CompletedByMeTodoView.vue?vue&type=script&lang=js"
export * from "./CompletedByMeTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports